<template>
  <div class="attendances d-flex align-items-stretch h-100">
    <div id="page-content-wrapper" class="col p-0 d-flex">
      <div v-show="loader" class="loader disable"></div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    loader() {
      return this.$store.state.loader;
    },
    articleType() {
      return this.$route.params.articleType;
    },
    articleId() {
      return this.$route.params.articleId;
    }
  },
  created() {
    if (!this.articleType || !this.articleId) {
      this.failedRoute();
    }
  },
  methods: {
    failedRoute() {
      this.$router.push({
        path: "/admins/url-not-valid"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.attendances {
  background-color: #f9f9f9;
}
</style>
